import { difference } from 'lodash';
import { datetime } from '@common/services/datetime';
import { BillingCardType } from '@institutions/graphql';

export function getRateCardsByComputedStatus(allCards: BillingCardType[] = []) {
  const activeCardIndex = allCards.findIndex(
    (card) => datetime(card.effectiveDate) <= datetime()
  );
  const activeCard = allCards[activeCardIndex];

  const futureCards =
    activeCardIndex === -1 ? allCards : allCards.slice(0, activeCardIndex);

  const upcomingCards: BillingCardType[] = [];

  futureCards.forEach((card) => {
    if (
      upcomingCards.length === 0 ||
      datetime(card.effectiveDate) <= datetime(upcomingCards[0].effectiveDate)
    ) {
      upcomingCards.unshift(card);
    }
  });

  const expiredCards = difference(allCards, [activeCard, ...upcomingCards]);

  const inEffectCards = activeCard
    ? [activeCard, ...upcomingCards]
    : upcomingCards;

  return { expiredCards, inEffectCards };
}
